import { render, staticRenderFns } from "./user-details-modal.component.vue?vue&type=template&id=e56159f4&scoped=true"
import script from "./user-details-modal.component.vue?vue&type=script&lang=ts"
export * from "./user-details-modal.component.vue?vue&type=script&lang=ts"
import style0 from "./user-details-modal.component.vue?vue&type=style&index=0&id=e56159f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56159f4",
  null
  
)

export default component.exports